import { PagingResultsViewModel, FilterSearchingBaseViewModel, EnumSiNoTodos } from 'src/app/components/core/_infrastructure/types/common';

export class OrganismosNocivosViewModel {
    public Id: number | null;
    public DataType: '';
    public Code: '';
    public CodeId: number | null;
    public Preferred: boolean;
    public Status: boolean;
    public FullName: '';
    public RegulatedUe: boolean;
    public NoEspecie: boolean;
}

export class OrganismosNocivosItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: OrganismosNocivosItemViewModel[];
}

export class OrganismosNocivosItemViewModel {
    public Id: number | null;
    public DataType: '';
    public DescripcionDataType: '';
    public Code: '';
    public CodeId: number | null;
    public Preferred: boolean;
    public FullName: '';
    public RegulatedUe: boolean;
    public NoEspecie: boolean;
}

export class FilterSearchingOrganismosNocivosViewModel extends FilterSearchingBaseViewModel {
    public DataType: '';
    public Code: '';
    public CodeId: number | null;
    public Preferred: number = EnumSiNoTodos.TODOS;
    public FullName: '';
    public RegulatedUe: number = EnumSiNoTodos.TODOS;
    public NoEspecie: number = EnumSiNoTodos.TODOS;
}
